var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['common-icon-btn', _vm.type === 'primary' ? 'primary' : 'plain'],on:{"click":_vm.handleBtnClick}},[_c('div',{staticClass:"icon"},[_vm._t("default")],2),_c('span',[_vm._v(" "+_vm._s(_vm.name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }